// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from 'firebase/firestore';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyC3vyRBxCMU63awigjGrTKKS3GAOd_LMD8",
  authDomain: "nutrisek-e7b81.firebaseapp.com",
  projectId: "nutrisek-e7b81",
  storageBucket: "nutrisek-e7b81.appspot.com",
  messagingSenderId: "224578704970",
  appId: "1:224578704970:web:719f7afb54c9c4fe7cf8b3",
  measurementId: "G-NNE10GFWRF"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const firestore = getFirestore(app);

export {
    firestore
}
